// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aa-PanelLayout {
  padding: 0;
}
.aa-GradientBottom {
  display: none;
}
.aa-Panel {
  z-index: var(--_18w76bw54);
  border-radius: var(--_18w76bw4p);
  padding-top: var(--_18w76bwg);
  padding-bottom: var(--_18w76bwg);
}
.aa-Panel button {
  height: var(--_18w76bwl);
  padding: 0;
  background: var(--_18w76bw2y);
}
.aa-Panel button[disabled] {
  background: var(--_18w76bw2z);
}
.aa-List  {
  z-index: var(--_18w76bw54);
  border-radius: var(--_18w76bw4p);
}
.aa-Panel mark {
  font-weight: var(--_18w76bw3z);
  background-color: transparent;
}
.aa-Autocomplete {
  width: 100%;
  flex-basis: 100%;
  margin: 0;
}
.aa-ClearButton {
  border-radius: var(--_18w76bw4s);
  padding: var(--_18w76bwa);
  border: 1.5px solid var(--_18w76bw2e);
  height: 14px;
}
.aa-ClearButton svg {
  display: none;
}
.aa-ClearButton::after {
  content: "";
  height: 1.5px;
  transform: rotate(45deg);
  width: 7px;
  position: absolute;
  background: var(--_18w76bw2e);
}
.aa-ClearButton::before {
  content: "";
  height: 1.5px;
  transform: rotate(-45deg);
  width: 7px;
  background: var(--_18w76bw2e);
}
._1dzttf40 {
  width: 100%;
  border: 0px;
  background-color: #FAFAFA;
  overflow: hidden;
}
._1dzttf40:focus-within {
  box-shadow: none;
}
._1dzttf41 {
  order: 1;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
  border-right: 0px;
}
._1dzttf41:focus-within {
  box-shadow: none;
  border-color: var(--_18w76bw35);
}
._1dzttf42 {
  order: 3;
  height: 46px;
}
._1dzttf43 {
  order: 2;
  position: absolute;
  right: 45px;
  z-index: var(--_18w76bw4y);
}
._1dzttf44 {
  padding-left: var(--_18w76bwe);
  padding-right: var(--_18w76bwl);
  font-family: var(--_18w76bw3k);
}
._1dzttf46 {
  width: 38px;
  height: 100%;
  padding-left: 0;
  padding-right: 0;
  border-radius: 4px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
  background-color: var(--_18w76bw2y);
  cursor: pointer;
}
._1dzttf46:hover {
  background-color: var(--_18w76bw2p);
}
._1dzttf46:active {
  background-color: var(--_18w76bw2p);
}
._1dzttf46 svg {
  color: white;
}
._1dzttf47 {
  background: transparent;
  width: 100%;
  padding: var(--_18w76bwe);
  border-bottom: 1px solid var(--_18w76bw28);
  position: relative;
}
._1dzttf47:first-child {
  padding-top: 0px;
}
._1dzttf47[aria-selected="true"] {
  background: transparent;
}
._1dzttf48:hover {
  text-decoration: underline;
}
._1dzttf47[aria-selected="true"] ._1dzttf48 {
  text-decoration: underline;
}
._1dzttf49[data-autocomplete-source-id="redirectUrlPlugin"] {
  display: none;
}
@media screen and (max-width: 767px) {
  .aa-Panel {
    padding-top: var(--_18w76bwe);
    position: fixed;
    top: 89px!important;
    left: 0!important;
    right: 0!important;
    height: 100%;
  }
}
@media screen and (min-width: 768px) {
  .aa-Panel {
    min-width: 565px;
    max-width: 735px!important;
    width: 100%!important;
  }
  .aa-Autocomplete {
    margin: 0 auto 0 0;
    max-width: 520px;
    min-width: auto;
    flex-basis: 65%;
  }
}
@media screen and (min-width: 860px) {
  .aa-Panel {
    max-width: 825px!important;
  }
}
@media screen and (min-width: 1024px) {
  .aa-Autocomplete {
    flex-basis: 100%;
  }
  .sm-autocomplete .aa-Autocomplete {
    flex-basis: 65%;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,QAAQ;EACR,YAAY;AACd;AACA;EACE,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;AACF;AACA;EACE;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".aa-PanelLayout {\n  padding: 0;\n}\n.aa-GradientBottom {\n  display: none;\n}\n.aa-Panel {\n  z-index: var(--_18w76bw54);\n  border-radius: var(--_18w76bw4p);\n  padding-top: var(--_18w76bwg);\n  padding-bottom: var(--_18w76bwg);\n}\n.aa-Panel button {\n  height: var(--_18w76bwl);\n  padding: 0;\n  background: var(--_18w76bw2y);\n}\n.aa-Panel button[disabled] {\n  background: var(--_18w76bw2z);\n}\n.aa-List  {\n  z-index: var(--_18w76bw54);\n  border-radius: var(--_18w76bw4p);\n}\n.aa-Panel mark {\n  font-weight: var(--_18w76bw3z);\n  background-color: transparent;\n}\n.aa-Autocomplete {\n  width: 100%;\n  flex-basis: 100%;\n  margin: 0;\n}\n.aa-ClearButton {\n  border-radius: var(--_18w76bw4s);\n  padding: var(--_18w76bwa);\n  border: 1.5px solid var(--_18w76bw2e);\n  height: 14px;\n}\n.aa-ClearButton svg {\n  display: none;\n}\n.aa-ClearButton::after {\n  content: \"\";\n  height: 1.5px;\n  transform: rotate(45deg);\n  width: 7px;\n  position: absolute;\n  background: var(--_18w76bw2e);\n}\n.aa-ClearButton::before {\n  content: \"\";\n  height: 1.5px;\n  transform: rotate(-45deg);\n  width: 7px;\n  background: var(--_18w76bw2e);\n}\n._1dzttf40 {\n  width: 100%;\n  border: 0px;\n  background-color: #FAFAFA;\n  overflow: hidden;\n}\n._1dzttf40:focus-within {\n  box-shadow: none;\n}\n._1dzttf41 {\n  order: 1;\n  border: 1px solid #d8d8d8;\n  border-radius: 4px;\n  border-bottom-right-radius: 0px;\n  border-top-right-radius: 0px;\n  border-right: 0px;\n}\n._1dzttf41:focus-within {\n  box-shadow: none;\n  border-color: var(--_18w76bw35);\n}\n._1dzttf42 {\n  order: 3;\n  height: 46px;\n}\n._1dzttf43 {\n  order: 2;\n  position: absolute;\n  right: 45px;\n  z-index: var(--_18w76bw4y);\n}\n._1dzttf44 {\n  padding-left: var(--_18w76bwe);\n  padding-right: var(--_18w76bwl);\n  font-family: var(--_18w76bw3k);\n}\n._1dzttf46 {\n  width: 38px;\n  height: 100%;\n  padding-left: 0;\n  padding-right: 0;\n  border-radius: 4px;\n  border-bottom-left-radius: 0px;\n  border-top-left-radius: 0px;\n  background-color: var(--_18w76bw2y);\n  cursor: pointer;\n}\n._1dzttf46:hover {\n  background-color: var(--_18w76bw2p);\n}\n._1dzttf46:active {\n  background-color: var(--_18w76bw2p);\n}\n._1dzttf46 svg {\n  color: white;\n}\n._1dzttf47 {\n  background: transparent;\n  width: 100%;\n  padding: var(--_18w76bwe);\n  border-bottom: 1px solid var(--_18w76bw28);\n  position: relative;\n}\n._1dzttf47:first-child {\n  padding-top: 0px;\n}\n._1dzttf47[aria-selected=\"true\"] {\n  background: transparent;\n}\n._1dzttf48:hover {\n  text-decoration: underline;\n}\n._1dzttf47[aria-selected=\"true\"] ._1dzttf48 {\n  text-decoration: underline;\n}\n._1dzttf49[data-autocomplete-source-id=\"redirectUrlPlugin\"] {\n  display: none;\n}\n@media screen and (max-width: 767px) {\n  .aa-Panel {\n    padding-top: var(--_18w76bwe);\n    position: fixed;\n    top: 89px!important;\n    left: 0!important;\n    right: 0!important;\n    height: 100%;\n  }\n}\n@media screen and (min-width: 768px) {\n  .aa-Panel {\n    min-width: 565px;\n    max-width: 735px!important;\n    width: 100%!important;\n  }\n  .aa-Autocomplete {\n    margin: 0 auto 0 0;\n    max-width: 520px;\n    min-width: auto;\n    flex-basis: 65%;\n  }\n}\n@media screen and (min-width: 860px) {\n  .aa-Panel {\n    max-width: 825px!important;\n  }\n}\n@media screen and (min-width: 1024px) {\n  .aa-Autocomplete {\n    flex-basis: 100%;\n  }\n  .sm-autocomplete .aa-Autocomplete {\n    flex-basis: 65%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
